import React from 'react';
import { BVShimmer } from '../../../models/BVShimmers/BVShimmer';
import './bv-shimmer-oneline.scss';

interface IBVShimmerOneLine extends BVShimmer { }

const BVShimmerDetails: React.FunctionComponent<IBVShimmerOneLine> = ({ style }) => (
    <div className="bv-shimmer-oneline" style={style}>
        <div className="shimmer-wrapper">
            <div className="shimmer-line shimmer-animation"></div>
        </div>
    </div>
);

export default BVShimmerDetails;